const DEVICE_LINK_CODE_PATTERN =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function extractDeviceLinkCode(qrContent: string): string | null {
  const trimmedContent = qrContent.trim();
  if (DEVICE_LINK_CODE_PATTERN.test(trimmedContent)) {
    return trimmedContent;
  }

  try {
    const parsedUrl = new URL(trimmedContent);
    const code = parsedUrl.searchParams.get('code')?.trim() ?? '';
    return DEVICE_LINK_CODE_PATTERN.test(code) ? code : null;
  } catch {
    const codeMatch = trimmedContent.match(
      /(?:^|[?&])code=([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})(?:$|[&#])/i
    );
    return codeMatch ? codeMatch[1] : null;
  }
}
